<template>
  <div class="card--organization">
    <v-row no-gutters>
      <v-col cols="3">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal overflow--hidden" v-on="on">
             {{ $t(`fleet.${vehicleClass.type}`) }}
            </span>
          </template>
           <span class="text--normal">{{ vehicleClass.type }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="3">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal overflow--hidden" v-on="on">
             {{ vehicleClass.organization.name }}
            </span>
          </template>
           <span class="text--normal">{{ vehicleClass.organization.name }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal overflow--hidden" v-on="on">
             {{ $t('fleet.number_of_vehicles') }}: {{ vehicleClass.count }}
            </span>
          </template>
           <span class="text--normal">{{ $t('fleet.number_of_vehicles') }}: {{ vehicleClass.count }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'VehicleClassOverviewCard',
  props: {
    vehicleClass: Object
  }
}
</script>

<style lang="scss" scoped>
  .card--organization {
    .text--normal {
      font-size: 14px;
      color: #484848;
      font-weight: 500;
      &.overflow--hidden {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 95%;
        display: block;
      }
    }
    .text--small {
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .text--slim {
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .card--dot {
      color: #767676;
      font-size: 11px;
      margin-left: 2px;
      margin-right: 2px;
    }
    .card--icon {
      font-size: 13px;
      font-weight: bold;
      color: #767676;
    }
    .card__vehicle {
      display: flex;
      .vehicle-name {
        display: inline-block;
        width: 125px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .card--label {
      font-size: 11px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      padding: 2px 8px;
      border-radius: 20px;
      margin-right: 5px;
      margin-bottom: 1px;
      background-color: #767676;
      &.label-green {
        background-color: #50E898;
      }
      &.label-pink {
        background-color: #ef476f;
      }
      &.label-purple {
        background-color: #6A68CD;
      }
    }
  }
</style>
